"use strict";
// NOTE: This code was generated and should not be changed
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHifiLandingLinkClickNonAuth = void 0;
/**
 * A builder for HifiLandingLinkClickNonAuth
 *
 * @param data - The event data
 * @return The formatted event data for HifiLandingLinkClickNonAuthEvent
 */
function createHifiLandingLinkClickNonAuth(data) {
    return {
        name: 'HifiLandingLinkClickNonAuth',
        environments: ['browsernonauth'],
        data: data,
    };
}
exports.createHifiLandingLinkClickNonAuth = createHifiLandingLinkClickNonAuth;
//# sourceMappingURL=createHifiLandingLinkClickNonAuth.js.map